module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black-menu"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('ul', {
    class: ['slick-in', {
      'fire-slick': _vm.isSticky
    }],
    attrs: {
      "id": "slick-in"
    }
  }, [(
    _vm.baseUrl == '/solutions' &&
    (_vm.$breakpoints.isMobile() || _vm.$breakpoints.isTablet())
  ) ? _c('li', {
    staticClass: "onlyMobile"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseUrl
    }
  }, [_vm._v("Multiple Disciplines")])]) : _vm._e(), _vm._v(" "), (
    _vm.baseUrl == '/agency' && (_vm.$breakpoints.isMobile() || _vm.$breakpoints.isTablet())
  ) ? _c('li', {
    staticClass: "onlyMobile"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseUrl
    }
  }, [_vm._v("Welcome to Marcus Thomas"), _c('Specialties')], 1)]) : _vm._e(), _vm._v(" "), (_vm.baseUrl == '/inclusion') ? _vm._l((_vm.moreList), function(index, i) {
    return _c('li', {
      key: i
    }, [_c('a', {
      class: _vm.$route.path == _vm.baseUrl + '/' + index.elements.url.value ?
        'item active' :
        'item',
      attrs: {
        "href": _vm.baseUrl + '/' + index.elements.url.value,
        "data-slide": i
      }
    }, [_vm._v(_vm._s(index.elements.page_name.value))])])
  }) : _vm._l((_vm.moreList), function(index, i) {
    return _c('li', {
      key: i
    }, [_c('a', {
      class: _vm.$route.path == _vm.baseUrl + '/' + index.elements.url.value ?
        'item active' :
        'item',
      attrs: {
        "href": _vm.baseUrl + '/' + index.elements.url.value,
        "data-slide": i
      }
    }, [_vm._v(_vm._s(index.elements.header_title.value))])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701977ed","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/submenu.vue
// module id = 1537
// module chunks = 0